export default {
  isFetching: false,
  isFetchingFilters: false,
  isFetchingRelatedInkItems: false,
  isFetchingRelatedMaintenanceItems: false,
  isFetchingPreviouslyPurchasedItems: false,
  isFetchingSavedItems: false,
  isFetchingSearchResults: false,
  orders: {
    total: 0,
    items: [],
    years: []
  },
  quotes: {
    total: 0,
    items: [],
    years: []
  },
  products: {
    total: 0,
    items: [],
    printer: null,
  },
  myProducts: {
    total: 0,
    items: []
  },
  shoppingCart: {
    total: 0,
    items: [],
    subtotal: 0,
    isFreeShipping: false
  },
  relatedInkItems: [],
  relatedMaintenanceItems: [],
  previouslyPurchasedItems: [],
  savedItems: [],
  savedPrinters: [],
  printerSearchResults: [],
  relatedItems: [],
  customerNumber: '',
  printer: null,
  filters: {},
  sales: {
    isFetching: false,
    total: 0,
    items: [],
    years: []
  },
};
